var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#292D32",
    fillOpacity: 0.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36992 15.3252C9.36992 15.3252 14.8133 13.0287 16.7012 12.22C17.4249 11.8966 19.8791 10.8615 19.8791 10.8615C19.8791 10.8615 21.0119 10.4087 20.9175 11.5084C20.886 11.9613 20.6343 13.5462 20.3826 15.2605C20.005 17.6864 19.5959 20.3387 19.5959 20.3387C19.5959 20.3387 19.533 21.0827 18.9981 21.2121C18.4632 21.3415 17.5822 20.7593 17.4249 20.6299C17.299 20.5328 15.065 19.0773 14.2469 18.3657C14.0267 18.1716 13.775 17.7835 14.2784 17.3306C15.4111 16.2632 16.7641 14.9371 17.5822 14.0961C17.9598 13.7079 18.3373 12.8023 16.7641 13.902C14.5301 15.4869 12.3276 16.9748 12.3276 16.9748C12.3276 16.9748 11.8242 17.2983 10.8802 17.0072C9.93625 16.7161 8.83499 16.3279 8.83499 16.3279C8.83499 16.3279 8.07988 15.8427 9.36992 15.3252Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/IconTelegram.512817073a87bdaa6859dcbdf93b98b9.svg";
export { ForwardRef as ReactComponent };